import React, { useState } from 'react';
import GlassPanel from './GlassPanel';
import UserDetails from './UserDetails';
import MFASettings from './MFASettings';
import PasswordChange from './PasswordChange';
import { FiUser, FiShield, FiLock } from 'react-icons/fi';
import '../styles/ProfileCard.css';

// Debug control - use i.e. DEBUG && console.log("whatever") and set below const true
const DEBUG = process.env.REACT_APP_DEBUG == 'enabled';

const ProfileCard = ({ user }) => {
  const [activeTab, setActiveTab] = useState('details');

  return (
    <div className="profile-card-container">
      <div className="profile-tabs">
        <button 
          className={`tab-button ${activeTab === 'details' ? 'active' : ''}`}
          onClick={() => setActiveTab('details')}
        >
          <FiUser className="tab-icon" />
          <span>Profile Details</span>
        </button>
        <button 
          className={`tab-button ${activeTab === 'mfa' ? 'active' : ''}`}
          onClick={() => setActiveTab('mfa')}
        >
          <FiShield className="tab-icon" />
          <span>MFA Settings</span>
        </button>
        <button 
          className={`tab-button ${activeTab === 'password' ? 'active' : ''}`}
          onClick={() => setActiveTab('password')}
        >
          <FiLock className="tab-icon" />
          <span>Change Password</span>
        </button>
      </div>

      <GlassPanel className="profile-content">
        {activeTab === 'details' && <UserDetails user={user} />}
        {activeTab === 'mfa' && <MFASettings user={user} />}
        {activeTab === 'password' && <PasswordChange />}
      </GlassPanel>
    </div>
  );
};

export default ProfileCard;